module.exports = __webpack_public_path__ + "img/2.58c61bd4.png";